module.exports = __webpack_public_path__ + "media/application/images/svgs/feather-7e0ef546597a5628a6534bebe5c7f766.svg";